$(document).ready(function() {    
    /* modal size guide */
    $("a#show-size-guide").click(function(){
    	$("#lightbox, #size-guide_modal, .size-guide_modal_cont").fadeIn(300);
	})
	$("#lightbox, a#close-modal, .size-guide_modal_cont").click(function(){
		$("#lightbox, #size-guide_modal, .size-guide_modal_cont").fadeOut(300);
	})
    
});

